import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  // set the currenr year
  year: number = new Date().getFullYear();

  constructor() {}

  ngOnInit(): void {}
}
